/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */

import { Client } from 'external/lwr-client';
import { parsePortletConfig } from '../utils/portlet-config-util';

const liferayWidgetsPortletService = (m, o) => Client.invoke('/liferay_widgets.widget/' + m, o);
//const liferayWidgetsPortletServiceWithContext = (m, o, c) => Client.invokeWithContext('/liferay_widgets.widget/' + m, o, c);

export default {

    getPortletProperties({ /*long*/scopeGroupId, /*long*/plid, /*String*/portletId }){
        return liferayWidgetsPortletService('get-portlet-properties.3', {
            scopeGroupId: scopeGroupId,
            plid: plid,
            portletId: portletId
        }).then(parsePortletConfig);
    },

    savePortletProperties({ /*long*/scopeGroupId, /*long*/plid, /*String*/portletId, properties }){
        const p = { ...properties };
        p && Object.keys(p).forEach(key => {
            const value = p[key];
            // Portlet properties only allow strings as values.
            if (typeof value === 'object' && value !== null) {
                try {
                    p[key] = JSON.stringify(value);
                } catch (e) {
                    console.warn(`Failed to parse config property ${key}: `, value);
                }
            }
        });
        return liferayWidgetsPortletService('save-portlet-properties.4', {
            scopeGroupId: scopeGroupId,
            plid: plid,
            portletId: portletId,
            properties: JSON.stringify(p)
        }).then(parsePortletConfig);
    }

};



// WEBPACK FOOTER //
// ./js/webapi/ConfigWebApi.js